export function mapState (...list) {
  return list.reduce((out, item) => {
    const [namespace, prop] = item.split('/');
    out[prop || namespace] = function () {
      const module = this.$store.stateMap.get(namespace);
      return prop ? module[prop] : module;
    };
    return out;
  }, {});
}

export function mapGetters (...list) {
  return list.reduce((out, item) => {
    const [namespace, prop] = item.split('/');
    out[prop || namespace] = function () {
      const module = this.$store.getters.get(namespace);
      return prop ? module[prop] : module;
    };
    return out;
  }, {});
}

export function mapActions (...list) {
  return list.reduce((out, item) => {
    out[item] = function (...args) {
      this.$dispatch(item, ...args);
    };
    return out;
  }, {});
}



// WEBPACK FOOTER //
// ./src/shared/stores/core/helpers.js